// let cpnBtn = document.getElementById("cpnBtn");
// let cpnCode = document.getElementById("cpnCode");
// let copyPastew = document.getElementById("copyPastew");

// copyPastew.onclick = function(){
//   navigator.clipboard.writeText(cpnCode.innerHTML);
//   cpnBtn.innerHTML = "Copied";
//   setTimeout(function(){
//     cpnBtn.innerHTML = "Tap to Copy";
//   },20000)
// }


// let cpnBtn = document.getElementById("cpnBtn");
// let cpnCode = document.getElementById("cpnCode");
// let copyPastew = document.getElementById("copyPastew");

// copyPastew.onclick = function(){
//   navigator.clipboard.writeText(cpnCode.innerHTML)
//     .then(() => {
//       cpnBtn.innerHTML = "Copied";
//       setTimeout(function(){
//         cpnBtn.innerHTML = "Tap to Copy";
//       }, 2000); 
//     })
//     .catch(err => {
//       console.error('Failed to copy: ', err);
//       // Optionally, provide feedback to user about the failure
//     });
// }


// function copyCouponCode() {
//   var couponCode = document.getElementById("cpnCode").innerText;
  
//   var dummyElement = document.createElement('textarea');
//   document.body.appendChild(dummyElement);
//   dummyElement.value = couponCode;
//   dummyElement.select();
//   document.execCommand('copy');
//   document.body.removeChild(dummyElement);
  
//   // Change button text to indicate it's copied
//   document.getElementById("cpnBtn").innerText = "copied";
// }
function copyCouponCode(couponCodeId, couponBtnId) {
  var couponCode = document.getElementById(couponCodeId).innerText;
  
  var dummyElement = document.createElement('textarea');
  document.body.appendChild(dummyElement);
  dummyElement.value = couponCode;
  dummyElement.select();
  document.execCommand('copy');
  document.body.removeChild(dummyElement);
  

  document.getElementById(couponBtnId).innerText = "Copied";
}

